import script from "./MessageBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageBoard.vue?vue&type=script&setup=true&lang=js"

import "./MessageBoard.vue?vue&type=style&index=0&id=4b958d7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b958d7c"]])

export default __exports__